<template>
  <Modal
    :is-open="modalState.isOpen"
    :title="modalState.title"
    :message="modalState.message"
    :variant="modalState.variant"
    :size="modalState.size"
    :show-close="modalState.showClose"
    :show-footer="modalState.showFooter"
    :show-cancel="modalState.showCancel"
    :confirm-text="modalState.confirmText"
    :cancel-text="modalState.cancelText"
    :loading="modalState.loading"
    :close-on-overlay="modalState.closeOnOverlay"
    :icon="modalState.icon"
    @close="handleClose"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  />
</template>

<script setup lang="ts">
import { useModal } from '@/composables/useModal'
import Modal from './Modal.vue'

const { modalState, close, confirm, cancel } = useModal()

function handleClose() {
  close()
}

async function handleConfirm() {
  await confirm()
}

function handleCancel() {
  cancel()
}
</script>

